"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const native_base_1 = require("native-base");
const theme_1 = require("theme");
const ModalInvoiceFilters = ({ onApply, onClean, ...rest }) => {
    const getFormattedDate = (newDate, oldDate) => {
        //validamos que solo se haya borrado el ultimo digito
        if (newDate === oldDate.substring(0, newDate.length)) {
            return newDate;
        }
        let [day, month, year] = newDate.split("/");
        if (day && month && year) {
            if (year.length > 4)
                return `${day}/${month}/${year.substring(0, 4)}`;
            return `${day}/${month}/${year}`;
        }
        else if (day && month) {
            if (month.length == 2)
                return `${day}/${month}/`;
            else
                return `${day}/${month}`;
        }
        else if (day) {
            if (day.length == 2)
                return `${day}/`;
            else
                return `${day}`;
        }
        return ``;
    };
    const [startDate, setStartDate] = React.useState("");
    const [endDate, setEndDate] = React.useState("");
    const onHandleChangeStartDate = (date) => {
        setStartDate(prevState => getFormattedDate(date, prevState));
    };
    const onHandleChangeEndDate = (date) => {
        setEndDate(prevState => getFormattedDate(date, prevState));
    };
    const onApplyPress = () => {
        onApply(startDate, endDate);
    };
    const onCleanPress = () => {
        setStartDate("");
        setEndDate("");
        onClean();
    };
    return (<native_base_1.Modal {...rest}>
			<native_base_1.Modal.Content>
				<native_base_1.Modal.CloseButton />
				<native_base_1.Modal.Header>{theme_1.Str.filter}</native_base_1.Modal.Header>
				<native_base_1.Modal.Body>
					<native_base_1.HStack px="20">
						<native_base_1.VStack flex="1">
							<native_base_1.Text variant="body5">
								{theme_1.Str.dateFrom.toUpperCase()}
							</native_base_1.Text>
							<native_base_1.Input value={startDate} onChangeText={onHandleChangeStartDate} placeholder={theme_1.Str.dateFormatInvoices} borderRadius={6}/>
						</native_base_1.VStack>
						<native_base_1.Text alignSelf="center" variant="h1">
							{" "}
							-{" "}
						</native_base_1.Text>
						<native_base_1.VStack flex="1">
							<native_base_1.Text variant="body5">
								{theme_1.Str.dateTo.toUpperCase()}
							</native_base_1.Text>
							<native_base_1.Input value={endDate} onChangeText={onHandleChangeEndDate} placeholder={theme_1.Str.dateFormatInvoices} borderRadius={6}/>
						</native_base_1.VStack>
					</native_base_1.HStack>
				</native_base_1.Modal.Body>
				<native_base_1.Modal.Footer pt={20}>
					<native_base_1.Button onPress={onCleanPress} colorScheme="btnSecondary" flex={1} mr="20">
						{theme_1.Str.clean}
					</native_base_1.Button>
					<native_base_1.Button onPress={onApplyPress} flex="1">
						{theme_1.Str.apply}
					</native_base_1.Button>
				</native_base_1.Modal.Footer>
			</native_base_1.Modal.Content>
		</native_base_1.Modal>);
};
exports.default = ModalInvoiceFilters;
